import { api } from '../createApi';
import { TagType } from '../TagType';

const TICKET_TAG_BY_LIST = { type: TagType.TicketK2, id: 'LIST' };
const WORKFLOW_TAG_BY_LIST = { type: TagType.Workflows, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.TicketK2 as TagType, TagType.Workflows as TagType],
  endpoints: {
    getTicketK2: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.TicketK2, id: arg.ticketId },
      ],
    },
    getStagesK2: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.TicketK2, id: arg.ticketId },
      ],
    },
    listTasksK2: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.TicketK2, id: arg.ticketId },
      ],
    },
    listTicketsK2: {
      providesTags: () => [TICKET_TAG_BY_LIST],
    },
    createTicketK2: {
      invalidatesTags: [TICKET_TAG_BY_LIST],
    },
    getWorkflowK2: {
      providesTags: (_result, _error, arg) => [
        { type: TagType.Workflows, id: arg.workflowId },
      ],
    },
    listWorkflowsK2: {
      providesTags: () => [WORKFLOW_TAG_BY_LIST],
    },
    createWorkflowK2: {
      invalidatesTags: [WORKFLOW_TAG_BY_LIST],
    },
    publishWorkflowK2: {
      invalidatesTags: (_result, _error, arg) => [
        WORKFLOW_TAG_BY_LIST,
        { type: TagType.Workflows, id: arg.workflowId },
      ],
    },
    unpublishWorkflowK2: {
      invalidatesTags: (_result, _error, arg) => [
        WORKFLOW_TAG_BY_LIST,
        { type: TagType.Workflows, id: arg.workflowId },
      ],
    },
  },
});
